<template>
  <Banner
    :image="HomeBannerImage"
    ariaLabel="Mulher em pose de largada"
    :minHeight="926"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg">
          <img class="corridaecaminhada img-fluid" :src="CorridaECaminhadaImage" alt="3ª Corrida e Caminhada - Cidade de Deus">
        </div>
        <div class="col-12 col-lg">
          <div class="modalides">
            <img class="corredor img-fluid" :src="RunnerIcon" alt="Ícone de Corredor"><br>
            <img class="inscricoesabertas img-fluid d-lg-none" :src="InscricoesAbertasMobileImage" alt="20 de outubro as 8h - Inscrições abertas!">
            <img style="max-width:439px" class="inscricoesabertas img-fluid d-none d-lg-block" :src="InscricoesAbertasImage" alt="20 de outubro as 8h - Inscrições abertas!">
            <router-link :to="{ name: 'resultado' }">
              <Button big>Confira seu resultado!</Button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="row iconList">
        <div class="col-12 col-lg text-center">
          <img class="img-fluid" :src="PeopleBannerHomeImage" alt="Funcionários - Estado do SP">
        </div>
        <div class="col-12 col-lg text-center">
          <img class="img-fluid" :src="MusicBannerHomeImage" alt="Show - Atração artística">
        </div>
        <div class="col-12 col-lg text-center">
          <img class="img-fluid" :src="TruckBannerHomeImage" alt="Food trucks">
        </div>
        <div class="col-12 col-lg text-center">
          <img class="img-fluid" :src="BaloonBannerHomeImage" alt="Atrações kids">
        </div>
      </div>
    </div>
    <BradescoLine/>
  </Banner>
</template>

<script>
import BradescoLine from '@/components/BradescoLine'
import PeopleBannerHomeImage from '@/images/peopleBannerHome.svg'
import MusicBannerHomeImage from '@/images/musicBannerHome.svg'
import TruckBannerHomeImage from '@/images/truckBannerHome.svg'
import BaloonBannerHomeImage from '@/images/baloonBannerHome.svg'
import RunnerIcon from '@/icons/runner.svg'
import Banner from '@/components/Banner'
import CorridaECaminhadaImage from '@/images/3-corrida-e-caminhada-cidade-de-deus.png'
import HomeBannerImage from '@/images/homeBanner.png'
import InscricoesAbertasImage from '@/images/inscricoes-abertas.svg'
import InscricoesAbertasMobileImage from '@/images/inscricoes-abertasMobile.svg'
import Button from '@/components/Button'

export default {
  name: 'BannerHome',
  components: {
    Banner,
    Button,
    BradescoLine,
  },
  data: () => ({
    PeopleBannerHomeImage,
    MusicBannerHomeImage,
    TruckBannerHomeImage,
    BaloonBannerHomeImage,
    InscricoesAbertasImage,
    CorridaECaminhadaImage,
    InscricoesAbertasMobileImage,
    HomeBannerImage,
    RunnerIcon,
  })
}
</script>

<style lang="scss" scoped>
.corredor {
  margin-top: 162px;
  margin-bottom: 16px;
  @media (max-width: 992px) {
    margin-top: 78px;
  }
}
.inscricoesabertas {
  margin-bottom: 14px;
  @media (max-width: 992px) {
    padding: 0 25px;
  }
}
.modalides {
  @media (max-width: 992px) {
    text-align: center;
  }
  img {
    display: block;
    @media (max-width: 992px) {
      display: inline-block;
    }
  }
}
.iconList {
  margin-top: 133px;
  @media (max-width: 992px) {
    margin-top: 78px;
    img {
      margin-bottom: 30px;
    }
  }
}
.corridaecaminhada {
  margin-top: 78px;
  @media (max-width: 992px) {
    display: block;

    width: 70%;
    margin: 78px auto 0;
  }
}
.text-center {
  text-align: center;
}
</style>
